<template>
  <section>
    <EventsHeader />
    <EventsIntro />
    <EventsIndex />
    <EventsMore />
    <NavigationCta />
  </section>
</template>

<script>
import * as partials from './partials'

export default {
  name: 'Events',
  components: { ...partials },
  provide() {
    return {
      wp: this.$wp.pages.events || {}
    }
  },
  mounted() {
    console.log('events', this.$wp.pages.events)
  }
}
</script>
